import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../../../../shared/services/local-storage/local-storage.service';
import { RetornoService } from '../../../../../shared/services/retorno/retorno.service';
import { CedenteService } from '../../../../../shared/services/cedente/cedente.service';
import * as moment from 'moment';
import { urls } from '../../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-retorno',
  templateUrl: './retorno.component.html',
  styleUrls: ['./retorno.component.scss']
})
export class RetornoComponent implements OnInit {
  public retornos: any[] = [];
  public cedentes: any[] = [];
  public cedente: any = null;
  public msgResult = '';
  public fileName = '';
  public error = false;
  public loaded = false;

  constructor(
    private localStorage: LocalStorageService,
    private retornoService: RetornoService,
    private cedenteService: CedenteService
  ) { }

  ngOnInit() {
    this.getCedentes();
    this.getRetornos();
  }

  getRetornos() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.retornoService.obterRetornos(user.PersonId).subscribe((data: any) => {
      this.retornos = data;
      this.retornos.forEach((retorno) => {
        const arquivo = retorno.Arquivo.split('\\');

        retorno.Arquivo = arquivo[arquivo.length - 1];
        retorno.ValorPago = retorno.ValorPago.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' });
      });

      this.retornos.sort(function(a, b) {
        if (moment(a.DataCadastro).isAfter(b.DataCadastro)) { return -1; }
        if (!moment(a.DataCadastro).isAfter(b.DataCadastro)) { return 1; }
        return 0;
      });

      this.showData();
    }, (err) => {
      this.error = true;
      console.error(err);
    });
  }

  showData() {
    $.fn.dataTable.moment('DD/MM/YYYY');

    const self = this;
    $(document).ready(function() {
      const table = $('#master-detail-table-retorno').DataTable({
        scrollX: true,
        destroy: true,
        paging: false,
        searching: false,
        processing: false,
        info: true,
        data: self.retornos,
        language: {
          emptyTable: ' ',
          info: '_START_ - _END_ de _MAX_',
        },
        initComplete: function() {
          self.loaded = true;

          if (self.retornos && self.retornos.length === 0) {
            $('#master-detail-table-retorno_info').html('0 - 0 de 0');
          }
        },
        columns: [
          {
            title: '',
            class: 'details-control',
            orderable: false,
            data: null,
            defaultContent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14">' +
                              '<title>icon-mais</title>' +
                              '<line x1="3" y1="7" x2="11" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                              '<line x1="7" y1="3" x2="7" y2="7" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                              '<line x1="7" y1="7" x2="7" y2="11" fill="none" stroke="#999" stroke-miterlimit="10" stroke-width="2"/>' +
                            '</svg>'
          },
          { title: 'Arquivo', data: 'Arquivo' },
          { title: 'Cedente', data: 'Cedente.RazaoSocial' },
          { title: 'Valor Pago Total', data: 'ValorPago' },
          { title: 'Quantidade de Registros', data: 'QtRegistros' },
          {
            title: '',
            class: 'download-retorno',
            data: null,
            orderable: false,
            render: function(data, type, row, meta) {
              const path = urls.apiBase + '/objetos/retornos/' + data.Arquivo;
              return '<a target="_blank" class="pull-right btn" href="' +
                     path +
                     '" download="' +
                     data.Arquivo + '"><span class="glyphicon glyphicon-download-alt"></span></a>';
            },
          },
        ],
      });

      const detailRows = [];

      $('#master-detail-table-retorno tbody').on( 'click', 'tr td.details-control', function () {
        const tr = $(this).closest('tr');
        const row = table.row( tr );
        const idx = $.inArray( tr.attr('id'), detailRows );

        if ( row.child.isShown() ) {
          $('div.slider', row.child()).slideUp(function () {
            tr.removeClass('details');
            tr.removeClass('shown');
            row.child.hide();
          });

          detailRows.splice( idx, 1 );
        } else {
          tr.addClass('details');

          row.child('<button class="btn btn-registrar loading"></button>').show();


          self.retornoService.obterPorId(row.data().RetornoId).subscribe((data: any) => {
            // data.Itens.sort(function(a, b) {
            //   if (a.NomeSacado > b.NomeSacado) { return -1; }
            //   if (a.NomeSacado < b.NomeSacado) { return 1; }
            //   return 0;
            // });

            row.child(self.format(data)).show();
            tr.addClass('shown');
            $('div.slider', row.child()).slideDown();
          }, (err) => {
            console.error(err);
          });

          if ( idx === -1 ) {
              detailRows.push( tr.attr('id') );
          }
        }
      });

      table.on('draw', function () {
        $.each(detailRows, function ( i, id ) {
            $('#' + id + ' td.details-control').trigger( 'click' );
        });
      });
    });
  }

  getCedentes() {
    const user = this.localStorage.get('login');

    if (!user || !user.PersonId) {
      return;
    }

    this.cedenteService.obterPorContaId(user.PersonId).subscribe((data: any) => {
      data.forEach((cedente) => {
        if (cedente.Padrao) {
          this.cedente = cedente;
        }
      });

      this.cedentes = data;
    }, (err) => {
      console.error(err);
    });
  }

  fileChange(e) {
    const file = $('#retorno-arquivo')[0].files[0];
    if (file) {
      this.fileName = file.name.substr(0, 20) + '...';
    }
  }

  selectCedente(cedente) {
    this.cedente = cedente;
  }

  submit(e) {
    e.preventDefault();

    const file = $('#retorno-arquivo')[0].files[0];
    const formData: FormData = new FormData();

    if (file) {
      formData.append('file', file, file.name);

      $('#btn-enviar-retorno').addClass('loading');

      this.retornoService.enviarRetorno(formData, this.cedente.CedenteId).subscribe(() => {
        $('#btn-enviar-retorno').removeClass('loading');
        this.msgResult = 'Arquivo enviado com sucesso!';
      }, (err) => {
        console.log(err);
        this.msgResult = 'Não foi possível enviar o arquivo';
        $('#btn-enviar-retorno').removeClass('loading');
      });
    }
  }

  format(d) {
    let tr = '';

    d.Itens.forEach((item) => {
      tr += '<tr>' +
              '<td>' + item.NomeSacado + '</td>' +
              '<td>' + item.AgenciaCobradora + '</td>' +
              '<td>' + item.BancoCobrador + '</td>' +
              '<td>' + item.DescricaoOcorrencia + '</td>' +
              '<td>' + item.ValorPago.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' }) + '</td>' +
            '</tr>';
    });

    return  '<div class="slider">' +
              '<table style="width: 100%;">' +
                '<thead>' +
                  '<tr>' +
                    '<th>Nome do Cliente</th>' +
                    '<th>Agência Recebedora</th>' +
                    '<th>Banco Recebedor</th>' +
                    '<th>Ocorrência</th>' +
                    '<th>Valor Pago</th>' +
                  '<tr>' +
                '</thead>' +
                '<tbody>' +
                  tr +
                '</tbody>' +
              '</table>' +
            '</div>';
  }
}
